/*
 *
 * GenericShopList
 *
 * @version 1.0.0
 * @author Alessandro Mancuso
 * @since 08-Oct-2025
*/

import { connect } from 'react-redux'
import SecondaryUserShopListModal from './SecondaryUserShopListModal'
import { doHidePopup } from 'Store/actions/popup'
import { nullSafe } from 'Utility/globalMethods'

const mapDispatchToProps = dispatch => ({
  doClosePopup: (type) => dispatch(doHidePopup(type))
})

const mapStateToProps = (state) => ({
  pointOfSalesData: nullSafe(() => state.popup.popupInfo.pointOfSalesData, [])
})

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps, mergeProps) => ({
  ...stateProps,
  ...mergeProps,
  actions: dispatchProps
}))(SecondaryUserShopListModal)
